export const SCOPES = ["https://www.googleapis.com/auth/drive.file"];

/** Root-level folder used to group drawOla files in the user's Drive. */
export const FOLDER_NAME = "drawOla";

/** MIME type written on create. */
export const MIME_TYPE = "application/vnd.drawOla+json";

/** Google Drive folder MIME. */
export const GOOGLE_FOLDER_MIME = "application/vnd.google-apps.folder";

/** Drive "appProperties" key used to tag files owned by drawOla. */
export const APP_PROPERTY_KEY = "drawOlaApp";
export const APP_PROPERTY_VALUE = "1";

/** Google Identity Services script. Loaded lazily from auth.ts. */
export const GSI_SRC = "https://accounts.google.com/gsi/client";

/** localStorage key for the access token and sealed refresh token. */
export const TOKEN_STORAGE_KEY = "drawOla_gdrive_token_v3";

/** sessionStorage key for the cached app folder id. */
export const FOLDER_STORAGE_KEY = "drawOla_gdrive_folder_v1";

/** Refresh silently this many ms before expiry. */
export const REFRESH_LEAD_MS = 5 * 60 * 1000;

/** Drive v3 base URL. */
export const DRIVE_API = "https://www.googleapis.com/drive/v3";
export const DRIVE_UPLOAD_API = "https://www.googleapis.com/upload/drive/v3";

/** 5 MB, the Drive simple upload cap. Also the provider's `maxUploadBytes`
 *  for the sync engine. */
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
